
import React from 'react'

import ContentHeaderToolbar, { ContentHeaderToolbarButton } from './ContentHeaderToolbar'
import ContentHeaderToolbarNav, { ContentHeaderNavTab } from './ContentHeaderNav'
import ContentHeaderTitle from './ContentHeaderTitle'

import './ContentHeader.scss'

interface Props {
  title: string
  buttons?: ContentHeaderToolbarButton[]
  navTabs?: ContentHeaderNavTab[]
  children?: any
}

const ContentHeader = ({ title, buttons, navTabs, children }: Props) => {

  return (
    <div className="content-header ul-widget__head">
      <ContentHeaderTitle title={title} />

      {buttons && buttons.length > 0 && (
        <ContentHeaderToolbar buttons={buttons} />
      )}
      {navTabs && navTabs.length > 0 && (
        <ContentHeaderToolbarNav tabs={navTabs} />
      )}

      {children}
    </div>
  )
}

export default ContentHeader
